import Vue from 'vue';

export const eventBus = new Vue();

export { eventBus as default };
